<template>
  <commonbody>
    <div class="corporation-details-header" slot="swiper">
    </div>
    <div class="clearfix common-width-box" id="corporation-details-box" :style="getCommonStyle.style">
      <div class="corporation-details-content">
        <div class="common-subtitle-box">
          葡旅空间<i>Tourist Space of Grapes</i>
        </div>
        <div class="corporation-details-content-box corporation-details-space">
          <p class="my-2">
            我们公司坐落于苏州园区通园路56文创园D栋，室内面积五百多平米，包括葡萄酒展厅，葡旅文化空间，办公室，恒温仓库。
          </p>
          <div class="row corporation-details-space-first">
            <div class="col-8 col-md-12 col-lg-8">
              <img src="../../public/images/zoom/1.png" alt="">
            </div>
            <div class="col-4 col-md-12 col-lg-4 py-md-4 py-lg-0 ">
              <div class="corporation-details-space-first-content">
                <span>酒会客厅</span>
                <img src="../../public/images/zoom/2.png" alt="">
              </div>
              <div class="my-2">
                <span>优质环境</span>
              </div>
              <div class="corporation-details-space-first-content">
                <span>文化宣传</span>
                <img src="../../public/images/zoom/3.png" alt="">
              </div>
            </div>
          </div>
          <div class="corporation-details-space-second row">
            <div v-for="(item, key) in spaceData" class="col-3 col-lg-3 col-md-6" :key="key">
              <p>{{ item.title }}</p>
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="corporation-details-content">
        <div class="common-subtitle-box">
          葡旅办公<i>Office environment</i>
        </div>
        <div class="corporation-details-content-box">
          <div class="row">
            <div class="col-4 col-lg-4 col-md-12 card border-0 px-2 py-0">
              <div class="common-subtitle-box" style="text-align: left;">办公环境</div>
              <div class="corporation-detils-second-content-text">
                <p>宽敞明亮的办公室内，舒适的氛围让人感觉如同家一般温馨，柔和的灯光洒在整洁的桌面上。</p>
                <p>每一张办公桌都布置得井然有序，绿色植物在窗外静静地点缀，为整个空间带来了自然的气息。</p>
              </div>
              <img src="../../public/images/zoom/9.png" />
            </div>
            <div class="col-8 col-lg-8 col-md-12 py-md-4 py-lg-0 card border-0 py-0 corporation-detils-second-content-img">
              <img src="../../public/images/zoom/8.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="corporation-details-content">
        <div class="common-subtitle-box">
          运输储存<i>Transportation and storage</i>
        </div>
        <div class="corporation-details-content-box corporation-detils-thrid-box">
          <div class="row">
            <div class="col-5 col-lg-5 col-md-12 card border-0 px-2 py-0">
              <div class="common-subtitle-box" style="text-align: left;">运输方式</div>
              <div class="corporation-detils-second-content-text">
                <p>葡萄酒对温度非常敏感，在运输过程中，应避免阳光直射葡萄酒，确保其在适宜的环境下运输打包时。需特别注意葡萄酒的储存条件，以保持其品质。因此夏天温度过高时，我们会采用冷链的运输方式，而冬天温度过低时，我们则会采用恒温的运输方式。</p>
                <p>合适的包装可以避免葡萄酒受到伤害，我们的纸箱用硬纸板制成，内部用泡沫包装保护葡萄酒使其免受碰撞和挤压。在极端天气下我们还会在泡沫包装外面包裹一层保温材料，这样即使离开恒温环境后，也能一定定程度上保证葡萄酒的品质风味。</p>
              </div>
              <div class="common-subtitle-box" style="text-align: left;">储存方式</div>
              <div class="corporation-detils-second-content-text">
                <p>葡萄酒的储存方式，往往能影响到他的品质和口感，葡萄酒的理想储存温度为10~15摄氏度，最高不应超过30摄氏度。保持恒温环境至关重要，因为温度的剧烈波动会影响葡萄酒的口感，过高的温度会加速葡萄酒的氧化过程，损害其香气和风味；而温度过低则会延缓葡萄酒的成熟，影响香气的释放。</p>
                <p>储存环境的相对湿度应保持在60%-70%左右。这样的温度水平有助于保持软木塞的适度温润，防止木塞干裂，同时减少氧气通过瓶口进入瓶内的可能性。</p>
                <p>通过遵循上述的运输与储存条件，可以有效地保护葡萄酒的品质，确保其在到达消费者手中时仍能保持最佳的风味和香气。</p>
              </div>
            </div>
            <div class="common-subtitle-box col-2 col-lg-2 col-md-12 text-md-left text-lg-center">运输流程</div>
            <div class="col-5 col-lg-5 col-md-12 card border-0 py-0 corporation-detils-thrid-content-img">
              <div class="row">
                <div class="col-6"  v-for="(item,key) in imgData" :key="key">
                  <img :src="item.url"/>
                </div>
              </div>
            </div>
          </div>
          <div class="common-subtitle-box" style="text-align: left;">恒温仓库</div>
          <div class="row">
            <div class="col-6 col-lg-6 card border-0">
              <img src="../../public/images/zoom/14.png" />
            </div>
            <div class="col-6 col-lg-6 card border-0">
              <img src="../../public/images/zoom/15.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </commonbody>
</template>

<script>
// @ is an alias to /src
import commonbody from '@/components/commonbody.vue';
import * as corporationApi from '@/api/corporation';
import { format, returnContentType } from '@/utils'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import { mapGetters } from "vuex";

export default {
  name: "CorporationDetails",
  components: {
    commonbody,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      detailsData: {},
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },
      imgData: [
        {
          url: require("../../public/images/zoom/10.png"),
        },
        {
          url: require("../../public/images/zoom/11.png"),
        },
        {
          url: require("../../public/images/zoom/12.png"),
        },
        {
          url: require("../../public/images/zoom/13.png"),
        }
      ],
      spaceData: [
        {
          title: '舒欣氛围',
          url: require("../../public/images/zoom/4.png"),
        },
        {
          title: '精品珍藏',
          url: require("../../public/images/zoom/5.png"),
        },
        {
          title: '酒会活动',
          url: require("../../public/images/zoom/6.png"),
        },
        {
          title: '储存仓库',
          url: require("../../public/images/zoom/7.png"),
        },
      ]
    };
  },
  computed: {
    ...mapGetters(['getCommonStyle']),
    swiper() {
      return this.$refs?.mySwiper?.$swiper;
    },
  },
  created() {
    // this.paramsUrl();
  },
  methods: {
    /**
     * @desc 获取时间
     */
    parseTime(string) {
      return format(new Date(string))
    },
    /**
     * @desc 检测页面参数是否完整
     */
    paramsUrl() {
      this.selectData();
    },
    /**
     * @desc 通过获取详细数据
     */
    selectData() {
      let params = {
      }
      corporationApi.selectData(params).then(res => {
        this.detailsData = res.data && res.data[0] || {};
      })
    },
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.corporation-details-header {
  height: 600px;
  width: 100%;
  position: relative;
  background: url('../../public/images/home/space/space1.png') center;
  background-size: contain;
}

#corporation-details-box {
  width: 80%;
  max-width: 1536px;
  margin: 0 auto;

  .corporation-details-content {
    text-align: left;
    color: #000;
    margin-bottom: 30px;

    .corporation-details-content-box {

      img {
        max-width: 100%;
      }

      .corporation-details-space {
        &-first {
          text-align: center;

          &-content {
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              margin-right: 15px;
            }

            img {
              max-width: 96%;
            }
          }
        }

        &-second {
          display: flex;
          justify-content: space-between;
          text-align: center;

          p {
            line-height: 30px;
            margin: 5px 0;
          }
        }
      }

      .corporation-detils-second-content-text {
        margin-bottom: 30px;
      }

      .corporation-detils-second-content-img {
        height: 550px;
        padding-left: 30px;

        img {
          max-height: 100%;
        }
      }

      &.corporation-detils-thrid-box {

        .row {
          justify-content: center;
          align-items: center;
        }
        img {
          height: 100%;
        }
        .corporation-detils-thrid-content-img {
          padding-left: 50px;
          img {
            margin-bottom: 30px;
            height: auto;
          }
        }
      }
    }
  }
}
</style>